import OneClickOptIn from './OneClickOptIn';
export default OneClickOptIn;